module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/148-madeira-4be69cfe494c80e4673fcad3634bbe03.svg";